var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobBehemalShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #879fa0;\n      }\n\n      .cls-2 {\n        fill: #6bff3b;\n      }\n\n      .cls-3 {\n        fill: #00bcb7;\n      }\n\n      .cls-4 {\n        fill: #9fbec1;\n      }\n\n      .cls-5 {\n        fill: #b4d1d6;\n      }\n\n      .cls-6 {\n        fill: aqua;\n      }\n\n      .cls-7 {\n        fill: #738d8e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "594.96 415.98 560.79 421.11 489.69 421.11 489.69 360.59 594.96 376.4 594.96 415.98"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "605.87 351.63 557.82 360.64 409.68 281.19 365.77 199.22 706.32 319.24 605.87 351.63"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "409.69 281.57 19.36 404.14 30.3 426.53 536.61 428.11 605.87 351.63 409.69 281.57"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "531.42 453.97 87.45 446.65 30.3 426.53 534.35 428.46 531.42 453.97"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "631 529.87 289.85 504.3 270.75 489.61 625.45 513.32 631 529.87"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "411.7 480.07 153.9 469.77 153.9 462.13 411.7 451.83 411.7 480.07"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "437.98 290.94 103.42 383.66 31.07 271.43 365.77 199.22 437.98 290.94"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "177.48 347.63 .32 364.65 9.6 176.77 31.07 271.43 177.48 347.63"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "625.95 513.32 271.22 490.09 240.72 427.19 536.23 428.46 625.95 513.32"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "437.98 290.94 605.82 351.44 125.81 399.83 19.36 404.14 .32 364.65 177.48 347.63 437.98 290.94"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "19.36 404.14 9.6 383.65 118.89 396.33 437.98 290.94 605.82 352.42 117.91 415.85 19.36 404.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobBehemalShip);
export default __webpack_public_path__ + "static/media/mob-behemal-ship.c10c1f096aabf146f05e58f64b123276.svg";
export { ForwardRef as ReactComponent };